export default __webpack_public_path__ + "static/media/Img054.614ff4ed.jpg";